import { Box } from '@mui/material';
import BoltOutlinedIcon from '@mui/icons-material/BoltOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import CallSplitOutlinedIcon from '@mui/icons-material/CallSplitOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import { CampaignsIcon, CouponsIcon, SurveysIcon } from 'assets/images/sidebar';
import { AUTOMATION_NODE_KIND } from '@constants/automations';

export const NODE_META = {
    [AUTOMATION_NODE_KIND.TRIGGER]: { icon: BoltOutlinedIcon, bg: '#EBF6F0', fg: '#1F4C5C' },
    [AUTOMATION_NODE_KIND.SEND_MESSAGE]: { icon: CampaignsIcon, isSvgAsset: true, bg: '#E3F0FB', fg: '#1976D2' },
    [AUTOMATION_NODE_KIND.SEND_COUPON]: { icon: CouponsIcon, isSvgAsset: true, bg: '#F3EBFA', fg: '#7B1FA2' },
    [AUTOMATION_NODE_KIND.SEND_SURVEY]: { icon: SurveysIcon, isSvgAsset: true, bg: '#E5F5EC', fg: '#0B8D00' },
    [AUTOMATION_NODE_KIND.WAIT]: { icon: ScheduleOutlinedIcon, bg: '#F0F0F0', fg: '#5F6368' },
    [AUTOMATION_NODE_KIND.BRANCH]: { icon: CallSplitOutlinedIcon, bg: '#FFEFDF', fg: '#ED6C02' },
    [AUTOMATION_NODE_KIND.EXIT]: { icon: LogoutOutlinedIcon, bg: '#F0F0F0', fg: '#5F6368' },
};

export const NodeIcon = ({ kind, size = 40 }) => {
    const meta = NODE_META[kind] || NODE_META[AUTOMATION_NODE_KIND.SEND_MESSAGE];
    const Icon = meta.icon;
    const iconSize = size / 2;

    return (
        <Box
            sx={{
                width: size,
                height: size,
                flexShrink: 0,
                borderRadius: '8px',
                background: meta.bg,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                '& svg path': { fill: meta.fg, fillOpacity: 1 },
            }}
        >
            {meta.isSvgAsset ? (
                <Icon width={iconSize} height={iconSize} />
            ) : (
                <Icon sx={{ fontSize: iconSize, color: meta.fg }} />
            )}
        </Box>
    );
};
